import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { ImportUser } from "../models/users/users/importUser";
import { UsersList } from "../models/users/users/usersList";
import { GenericResponseDto } from "../models/generic-response.dto";

@Injectable({
  providedIn: "root",
})
export class ImportUserService {
  private userManagementBaseURL = environment.baseUrl + "/User";
  constructor(private _http: HttpClient) {}

  createUser(payload: ImportUser[]): Observable<GenericResponseDto<UsersList>> {
    return this._http.post<GenericResponseDto<UsersList>>(
      this.userManagementBaseURL + "/ImportADUsers",
      {
        Users: payload,
      }
    );
  }
}
